<template>
  <div class="max-w-2xl mx-auto py-8">
    <FuelTransactionForm @save="handleSave" @cancel="handleCancel" :loading="loading" />
    <div v-if="success" class="mt-6 p-4 bg-green-50 border border-green-200 rounded text-green-800">
      Fuel transaction created successfully.
    </div>
    <div v-if="error" class="mt-6 p-4 bg-red-50 border border-red-200 rounded text-red-800">
      {{ error }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useFuelStore } from '@/stores/fuelStore'
import FuelTransactionForm from '@/components/fuel/FuelTransactionForm.vue'
import { useRouter } from 'vue-router'
import type { FuelTransactionCreate } from '@/types/fuel'

const fuelStore = useFuelStore()
const loading = ref(false)
const success = ref(false)
const error = ref('')
const router = useRouter()

const handleSave = async (data: FuelTransactionCreate) => {
  loading.value = true
  error.value = ''
  success.value = false
  try {
    await fuelStore.createTransaction(data)
    success.value = true
    setTimeout(() => {
      router.push({ name: 'FuelView' })
    }, 1200)
  } catch (err: unknown) {
    if (err instanceof Error) {
      error.value = err.message
    } else if (err && typeof err === 'object' && 'message' in err) {
      // err may be an object with a message property
      const maybeMsg = (err as { message?: unknown }).message
      error.value =
        typeof maybeMsg === 'string'
          ? maybeMsg
          : String(maybeMsg ?? 'Failed to create fuel transaction.')
    } else {
      error.value = 'Failed to create fuel transaction.'
    }
  } finally {
    loading.value = false
  }
}

const handleCancel = () => {
  router.push({ name: 'FuelView' })
}
</script>
